@use '../@shared/mixins' as *;
@use '../../styles/global' as *;
@use '../tooltip/style.scss' as *;
@use '../@shared/kol-pagination-mixin' as *;

@layer kol-component {
	@include kol-pagination-styles;
}
